import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=4d13fefb&scoped=true&"
import script from "@/views/Users/Root/Dashboard.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Root/Dashboard.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Root/dashboard.scss?vue&type=style&index=0&id=4d13fefb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13fefb",
  null
  
)

export default component.exports